/*
 * QBP — Hero slideshow (sections/custom-slidshow.liquid).
 * Vanilla, sans dépendance. Autoplay, swipe, clavier, barre de progression,
 * bouton pause (WCAG 2.2.2), slides programmées par date via window.QBPSchedule
 * (snippets/qbp-schedule-script.liquid), slide exclusive, compte à rebours.
 *
 * Liquid pré-sélectionne les slides visibles pour le premier affichage ; ce
 * script recalcule côté client (HTML caché au CDN) puis toutes les minutes.
 * Éditeur de thème : sélectionner un bloc force l'aperçu de sa slide.
 */
(function () {
  'use strict';

  if (window.QBPSlideshow) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var toArray = function (list) { return Array.prototype.slice.call(list); };

  function editorBlockId(el) {
    try { return JSON.parse(el.getAttribute('data-shopify-editor-block')).id; } catch (e) { return null; }
  }

  function init(root) {
    if (!root || root.getAttribute('data-qbp-init')) return;
    root.setAttribute('data-qbp-init', '1');

    var S = window.QBPSchedule;
    var all = toArray(root.querySelectorAll('[data-qbp-slide]'));
    var allDots = toArray(root.querySelectorAll('[data-qbp-dot]'));
    var controls = root.querySelector('[data-qbp-controls]');
    var current = root.querySelector('[data-qbp-current]');
    var total = root.querySelector('[data-qbp-total]');
    var progress = root.querySelector('[data-qbp-progress]');
    var toggle = root.querySelector('[data-qbp-toggle]');
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;

    var slides = [], idx = 0, timer = null, userPaused = false, forced = null;

    function now() { return S ? S.now() : Date.now(); }

    function visibleSlides(t) {
      var on = all.filter(function (s) {
        return !S || S.inWindow(s.getAttribute('data-start'), s.getAttribute('data-end'), t);
      });
      var exclusive = on.filter(function (s) { return s.getAttribute('data-exclusive') === 'true'; });
      if (exclusive.length) on = [exclusive[0]];
      if (forced && on.indexOf(forced) === -1) {
        on = all.filter(function (s) { return s === forced || on.indexOf(s) !== -1; });
      }
      return on;
    }

    function restartProgress() {
      if (!progress || delay === 0 || reduce) return;
      progress.classList.remove('is-running');
      void progress.offsetWidth;
      progress.classList.add('is-running');
    }

    function go(n) {
      if (!slides.length) return;
      idx = (n + slides.length) % slides.length;
      var activeEl = slides[idx];
      all.forEach(function (s, i) {
        var active = s === activeEl;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (allDots[i]) {
          allDots[i].classList.toggle('is-active', active);
          allDots[i].setAttribute('aria-selected', active ? 'true' : 'false');
        }
      });
      if (current) current.textContent = idx + 1;
      restartProgress();
    }

    function next() { go(idx + 1); }
    function prev() { go(idx - 1); }

    function play() {
      if (delay === 0 || reduce || userPaused || forced || slides.length < 2) return;
      stop();
      timer = setInterval(next, delay);
      root.classList.add('is-playing');
      restartProgress();
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      root.classList.remove('is-playing');
    }

    function updateCountdowns(t) {
      slides.forEach(function (s) {
        var cd = s.querySelector('[data-qbp-slide-countdown]');
        if (!cd || !S) return;
        var left = S.toEpoch(s.getAttribute('data-end')) - t;
        var value = cd.querySelector('[data-qbp-countdown-value]');
        cd.hidden = isNaN(left) || left <= 0;
        if (!cd.hidden && value) value.textContent = S.format(left);
      });
    }

    function sync() {
      var t = now();
      var before = slides[idx] || all.filter(function (s) { return s.classList.contains('is-active'); })[0];
      var countBefore = slides.length;
      slides = visibleSlides(t);

      all.forEach(function (s, i) {
        var on = slides.indexOf(s) !== -1;
        s.hidden = !on;
        if (allDots[i]) allDots[i].hidden = !on;
      });
      slides.forEach(function (s, i) { s.setAttribute('aria-label', (i + 1) + ' / ' + slides.length); });
      root.hidden = slides.length === 0;
      if (controls) controls.hidden = slides.length < 2;
      if (total) total.textContent = slides.length;

      var target = forced ? slides.indexOf(forced) : slides.indexOf(before);
      if (target === -1) target = 0;
      if (target !== idx || slides[target] !== before || slides.length !== countBefore) go(target);
      updateCountdowns(t);
      if (slides.length < 2) stop();
    }

    function setUserPaused(paused) {
      userPaused = paused;
      root.classList.toggle('is-paused-user', paused);
      if (toggle) toggle.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre en pause le défilement');
      paused ? stop() : play();
    }

    var prevBtn = root.querySelector('[data-qbp-prev]');
    var nextBtn = root.querySelector('[data-qbp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); play(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); play(); });
    allDots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(slides.indexOf(all[i])); play(); });
    });
    if (toggle) {
      if (delay === 0 || reduce) toggle.hidden = true;
      toggle.addEventListener('click', function () { setUserPaused(!userPaused); });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); play(); }
      else if (e.key === 'ArrowRight') { next(); play(); }
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      x0 = null; play();
    }, { passive: true });

    var onVisibility = function () {
      if (document.hidden) { stop(); return; }
      sync(); play();
    };
    document.addEventListener('visibilitychange', onVisibility);

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? play() : stop(); });
      }, { threshold: 0.2 });
      observer.observe(root);
    }

    sync();
    if (!observer) play();
    var clock = setInterval(sync, 60000);

    root._qbpSlideshow = {
      select: function (blockId) {
        forced = all.filter(function (s) { return editorBlockId(s) === blockId; })[0] || null;
        stop();
        sync();
      },
      deselect: function () {
        forced = null;
        sync();
        play();
      },
      destroy: function () {
        stop();
        clearInterval(clock);
        document.removeEventListener('visibilitychange', onVisibility);
        if (observer) observer.disconnect();
      }
    };
  }

  function rootFor(e) {
    if (!e.detail || !e.detail.sectionId) return null;
    return document.querySelector('[data-qbp-slideshow][data-section-id="' + e.detail.sectionId + '"]');
  }

  toArray(document.querySelectorAll('[data-qbp-slideshow]')).forEach(init);

  document.addEventListener('shopify:section:load', function (e) { init(rootFor(e)); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = rootFor(e);
    if (root && root._qbpSlideshow) root._qbpSlideshow.destroy();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = rootFor(e);
    if (root && root._qbpSlideshow) root._qbpSlideshow.select(e.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = rootFor(e);
    if (root && root._qbpSlideshow) root._qbpSlideshow.deselect();
  });

  window.QBPSlideshow = { init: init };
})();
